<template>
  <footer class="container footer footer-ds">
    <div class="row">
      <div class="col-md-3">

      </div>
      <div class="col-md-6">
        <p class="mb-md-0 mb-0">We are dedicated to protecting your private information. </p>
        <a role="button" style="color:#ffffff" class="footer__link" @click="nextRoute('protection')">Click here to learn more about information protection</a>
      </div>
      <div class="col-md-3">
        <a role="button" class="footer__link">Help and Support</a>
        <a role="button" class="footer__link" @click="nextRoute('terms')">Terms & Conditions</a>
        <a role="button" class="footer__link" @click="nextRoute('privacy-policy')" >Privacy Policy</a>
      </div>
    </div>
  </footer>
</template>

<script>
import router from '@/router/index';
  export default {
    name: "FooterBar",
    methods: {
      nextRoute(route){
        router.push(`/${route}`)
      }
    }
  }
</script>

<style scoped lang="scss">
  $color-base: #24555b; /* deep teal — solid, no fade */

  .footer {
    max-width: 100%;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    background-color: $color-base;
    color: #fff;
    font-size: 0.8rem;
    text-align: center;
    font-family: "Inter", system-ui, sans-serif;
    
    .footer__link {
      display: block;
      color: #ffffff;
      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }
    position: absolute;
    bottom: 0;
  }

</style>